import { motion } from 'framer-motion'

// Utils
import { pageVariants } from 'components/interestform/utils'

import commonStyles from 'components/interestform/slides/common.css'
import styles from './sampleclassification.css'

const SampleClassification = (): JSX.Element => {
  return (
    <motion.div className={commonStyles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <h1 className={commonStyles.heading}>Sample length determination</h1>
      <div className={commonStyles.subheading}>
        Tracklib&apos;s sample length calculation is based on the length in it&apos;s original format. Sometimes producers want just an
        orchestral hit or even a snare drum, other times a substantial loop. No matter what they want, we’ve got it covered. The total
        sample length is cumulative – it doesn&apos;t have to be a continuous piece
      </div>
      <div className={styles.infographicsWrapper}>
        <div className={styles.infographic}>
          <div className={styles.infographicImageWrapper}>
            <img className={styles.infographicImg} src="/static/images/interestform/two-second-sample.jpg" alt="Record Illustration" />
          </div>
          <div className={styles.infographicTextWrapper}>
            <div className={styles.infographicTitle}>
              <strong>&lt; 2 Seconds</strong>
            </div>
            <div className={styles.infographicText}>Single sound/musical element max 2 seconds in length</div>
          </div>
        </div>
        <div className={styles.infographic}>
          <div className={styles.infographicImageWrapper}>
            <img className={styles.infographicImg} src="/static/images/interestform/fifteen-second-sample.jpg" alt="Record Illustration" />
          </div>
          <div className={styles.infographicTextWrapper}>
            <div className={styles.infographicTitle}>
              <strong>&lt; 15 Seconds</strong>
            </div>
            <div className={styles.infographicText}>Up to 15 seconds in length</div>
          </div>
        </div>
        <div className={styles.infographic}>
          <div className={styles.infographicImageWrapper}>
            <img className={styles.infographicImg} src="/static/images/interestform/sixty-second-sample.jpg" alt="Dollars" />
          </div>
          <div className={styles.infographicTextWrapper}>
            <div className={styles.infographicTitle}>
              <strong>&lt; 60 Seconds</strong>
            </div>
            <div className={styles.infographicText}>Between 15 seconds up to 1 minute in length</div>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default SampleClassification
